import { reportAccessFailure } from './reportAccessFailure';

/** User mistakes — do not page admins. */
const USER_LOGIN_ERRORS = new Set([
  'auth/user-not-found',
  'auth/wrong-password',
  'auth/invalid-credential',
  'auth/invalid-email',
]);

/**
 * Alert admins for login failures that indicate outage or misconfiguration,
 * not wrong passwords.
 */
export function reportLoginFailureIfSystemic(
  code: string | undefined,
  message: string | undefined
): void {
  if (!code || USER_LOGIN_ERRORS.has(code)) {
    return;
  }

  const kind = code === 'auth/network-request-failed' ? 'login_network_failed' : 'login_auth_error';

  reportAccessFailure({
    kind,
    route: '/login',
    message: message ? `${code}: ${message}` : code,
  });
}
